import React from 'react';
import { FaLightbulb, FaMoon, FaThermometerHalf, FaBolt, FaChevronRight } from 'react-icons/fa';

const UpcommingAndOverdue = () => {

    const upcomming = [
        {
            icon: FaBolt,
            title: "Pat Inspection",
            date: "Due On 1 Jun 2025",
            branch: "Knightsbridge",
            badgeColor: 'bg-indigo-50 text-indigo-700 border-indigo-100',
            bgColor: "bg-orange-500"
        },
        {
            icon: FaLightbulb,
            title: "Opening Check",
            date: "Tomorrow 07:00",
            branch: "Knightsbridge",
            badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
            bgColor: 'bg-amber-500' 
        }
    ];

    const overdue = [
        {
            icon: FaMoon,
            title: "Closing Check",
            date: "Due On 1 Jun 2025",
            branch: "Knightsbridge",
            badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
            bgColor: "bg-blue-500"
        },
        {
            icon: FaThermometerHalf,
            title: "Food Temperature Log",
            date: "Due On 1 Jun 2025",
            branch: "Knightsbridge",
            badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
            bgColor: "bg-green-500"
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-xl">
            {/* Left Side: Upcoming List */}
            <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center justify-between">
                    <span>Upcoming Tasks</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full font-medium">
                        {upcomming.length} Total
                    </span>
                </h2>
                <div className="space-y-3">
                    {upcomming.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div key={index} className="flex items-center justify-between p-3.5 bg-gray-50 hover:bg-gray-100/70 rounded-lg transition-colors border border-gray-100">
                                <div className="flex items-center gap-3">
                                    <div className={`p-2.5 rounded-lg text-white ${item.bgColor}`}>
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800 text-sm">{item.title}</h3>
                                        <p className="text-xs text-gray-500 mt-0.5">{item.date}</p>
                                    </div>
                                </div>
                                <span className={`text-xs px-2.5 py-1 rounded-md border font-medium ${item.badgeColor}`}>
                                    {item.branch}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Right Side: Overdue List */}
            <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                <h2 className="text-lg font-bold text-red-600 mb-4 flex items-center justify-between">
                    <span>Overdue Tasks</span>
                    <span className="text-xs bg-red-50 text-red-600 px-2.5 py-1 rounded-full font-medium">
                        {overdue.length} Action Required
                    </span>
                </h2>
                <div className="space-y-3">
                    {overdue.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div key={index} className="flex items-center justify-between p-3.5 bg-red-50/30 hover:bg-red-50/60 rounded-lg transition-colors border border-red-100/50 group cursor-pointer">
                                <div className="flex items-center gap-3">
                                    <div className={`p-2.5 rounded-lg text-white ${item.bgColor}`}>
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800 text-sm group-hover:text-red-700 transition-colors">{item.title}</h3>
                                        <p className="text-xs text-red-500 font-medium mt-0.5">{item.date}</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <span className={`text-xs px-2.5 py-1 rounded-md border font-medium ${item.badgeColor}`}>
                                        {item.branch}
                                    </span>
                                    <FaChevronRight className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-0.5 transition-all" />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default UpcommingAndOverdue;
